import { render, staticRenderFns } from "./CoEvent.vue?vue&type=template&id=7cbe069b&scoped=true&"
import script from "./CoEvent.vue?vue&type=script&lang=ts&"
export * from "./CoEvent.vue?vue&type=script&lang=ts&"
import style0 from "./CoEvent.vue?vue&type=style&index=0&id=7cbe069b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbe069b",
  null
  
)

export default component.exports